/**
 * Theme Toggle Component
 * Allows switching between light, dark, and system themes
 */

import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const themes = [
    { value: 'light' as const, icon: Sun, label: 'Light' },
    { value: 'dark' as const, icon: Moon, label: 'Dark' },
    { value: 'system' as const, icon: Monitor, label: 'System' },
  ];

  const currentTheme = themes.find(t => t.value === theme) || themes[2];
  const Icon = currentTheme.icon;

  return (
    <button
      onClick={() => {
        const currentIndex = themes.findIndex(t => t.value === theme);
        const nextIndex = (currentIndex + 1) % themes.length;
        setTheme(themes[nextIndex].value);
      }}
      className="p-2 rounded-lg hover:bg-cream-200 dark:hover:bg-charcoal-700 transition-colors"
      title={`Theme: ${currentTheme.label} (click to cycle)`}
      aria-label={`Current theme: ${currentTheme.label}. Click to cycle themes.`}
    >
      <Icon className="w-5 h-5" />
    </button>
  );
}
